import axios from "axios";

const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASE || "",
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
});

export default http;
